import { BaseModal, ModalResultType, ModalOptions, ModalColor } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";
import { AttributeKey, LastAuthentication } from "../../db/models/attributes";
import CoreIcons from "../../icons";
import { OfflineError } from "../../app/api";
import { lang } from "moment";
import { userInfo } from "os";

type AccountInfo = {[key:string]: any};


export default class AuthenticationModal extends BaseModal
{
    public template = Template.lazy('/core/modals/authentication/index.html');

    public data: AuthenticationModalViewData;

    public get defaults(): AuthenticationModalViewData
    {
        return {
            title: this.pgettext('Title', 'Authentication'),
            message: '',
            iconClass: CoreIcons.Authentication,
            color: ModalColor.BLUE
        }
    }

    public beforeRender()
    {
        return super.beforeRender();
    }

    private getChecksum(): number
    {
        return this.data.username.split('').concat(this.data.password.split('')).map((c) => c.charCodeAt(0)).reduce((a, b) => a + b, 0);
    }

    public formSubmitted(form: HTMLFormElement): PromiseLike<void>
    {
        this.helpers.setFormEnabled(form, false);

        return this.app.api.public('login', {
            username: this.data.username,
            password: this.data.password
        }).then((result) =>
        {
            if (!result)
            {
                this.data.message = this.pgettext('Error', 'Username or password is invalid.');
            }
            else
            {
                this.finalizeAuthentication(result);
            }
            this.helpers.setFormEnabled(form, true);
        }, (error) =>
        {
            if (error instanceof OfflineError)
            {
                let checksum = this.getChecksum();

                this.app.db.Attribute.get(AttributeKey.LAST_AUTHENTICATION).then((lastAuthentication: LastAuthentication) =>
                {
                    if (lastAuthentication && lastAuthentication.checksum === checksum)
                    {
                        console.log('[Authentcation] Authenticated offline with last known successfull authentcation.');
                        this.finalizeAuthentication(lastAuthentication);
                    }
                    else
                    {
                        this.authenticationFailed(error as any, form, this.pgettext('Error', 'Username or password is invalid.'));
                    }
                });
            }
            else
            {
                this.authenticationFailed(error, form,);
            }
        });
    }

    private authenticationFailed(error: Error, form: HTMLFormElement, errorMessage?: string)
    {
        this.data.message = errorMessage || this.pgettext('Error', 'Unable to sign in. Please try again later.');
        console.error(error);
        this.helpers.setFormEnabled(form, true);
    }

    // private finalizeAuthentication(token: string, userId: number, languageCode = navigator.language)
    private finalizeAuthentication(info: AccountInfo)
    {
        this.app.userSettings = {
            token: info.token,
            id: info.id || info.user, // info.user is now deprecated, use info.id instead 
            key: AttributeKey.CURRENT_USER,
            language: info.language,
            permissions: info.permissions || {}
        };

        let lastAuthentication: LastAuthentication = {
            key: AttributeKey.LAST_AUTHENTICATION,
            id: this.app.userSettings.id,
            language: this.app.userSettings.language,
            token: this.app.userSettings.token,
            checksum: this.getChecksum(),
            permissions: this.app.userSettings.permissions
        };
        
        this.app.db.Attribute.bulkPut([lastAuthentication, this.app.userSettings]).then(() =>
        {
            this.close();
        }).catch((err) =>
        {   
            this.data.message = this.pgettext('Error', 'Unable to sign in. Please try again later.');
            console.error(err);
            throw err;
        });
    }
}

export interface AuthenticationModalViewData extends ModalOptions
{
    username?: string;
    password?: string;
}